import type { FeedItems } from "../../../types/content/feedItem";

import { isFeedItem } from "../../../utils/typechecks";

const omitRepeated = (
  prevGroup: FeedItems,
  nextGroupToAdd: FeedItems,
  initialItems: FeedItems,
  onlyNewGroups?: boolean,
): FeedItems => {
  const previousFeedItems = [...initialItems, ...prevGroup]
    .filter((feedItem) => isFeedItem(feedItem))
    .filter((feedItems) => feedItems.id);

  const filteredArticles = nextGroupToAdd.filter(
    (item) =>
      previousFeedItems.length === 0 ||
      (isFeedItem(item) &&
        previousFeedItems.every((prevFeedItem) => prevFeedItem.id !== item.id)),
  );
  return onlyNewGroups
    ? [...filteredArticles]
    : [...prevGroup, ...filteredArticles];
};

export { omitRepeated };
